import React from 'react';
import { TextFieldBlock } from '../TextFieldBlock';
import { InstructionsToExtractors } from '../../shared/InstructionsToExtractors';
import { IconAndTitle } from '../../shared/IconAndTitle';
import { HydratedBlockProps } from '../../BaseBlock';

export type TextFieldEditorSettingsProps = {
  block: TextFieldBlock & HydratedBlockProps;
  onChange: (updatedBlock: TextFieldBlock) => void;
};

export function TextFieldEditorSettings({
  block,
  onChange,
}: TextFieldEditorSettingsProps): JSX.Element {
  return (
    <>
      <IconAndTitle icon={block.icon} title={block.title} />

      <hr />

      <InstructionsToExtractors block={block} onChange={onChange} />
      <hr />
    </>
  );
}
